/*
レッスンページの OGP に何を出すかを決める。

**コースの共有の絵 (scripts/ogp-site/build.ts が書き出す 1200x630) を先に出す。**
サムネの絵柄 (キャラと題材の道具、淡い地と丘と雲、右上の丸の判子) の窓に、コースの名前を組んだ札。
2026-10-21 に代表がこの絵柄を OGP に広げると決めたので、レッスンもコースの頁と同じ札にそろえる。
札は yumesaku.tech の /assets の下にあり、名前に中身のハッシュが付く (1 年 immutable)。

**レッスンの題名は絵にしない。** X も Discord もカードの中でリンク名を文字で出すので、
2,421 本ぶんの絵を持つより、コースごとの札 116 枚を使い回す。生成の経路
(satori と resvg) も通らないので、2026-09-05 の「1x1 の透明 PNG を X が覚えた」ような壊れ方もしない。

札の無いコース (書き出したあとに足したコース) は、コースのサムネイル、それも無ければ生成した絵に落ちる
*/

import { toCanonicalStorageUrl } from "./og-image-host";

const ORIGIN = "https://yumesaku.tech";

export type LessonOgImageInput = {
  courseSlug: string;
  lessonSlug: string;
  /** コースの共有の絵 (lib/seo/site-ogp.server.ts の siteOgpImage("course", …))。表は loader だけが読むので、呼ぶ側が渡す */
  courseOgpImageUrl?: string | null;
  courseThumbnailUrl?: string | null;
};

/**
 * DB の値をそのまま og:image に流さない。
 *
 * クローラに渡す URL なので、絶対 https か、自分のところの絶対パスだけを
 * 通す。`javascript:` や `data:` が入っていた場合にそのまま出さないため
 */
function absoluteImageUrl(raw: string | null | undefined): string | null {
  const value = raw?.trim();
  if (!value) return null;
  if (value.startsWith("https://")) return toCanonicalStorageUrl(value);
  // `//host/x.png` は path ではなく別ホストへの参照。前に origin を足すと
  // `https://yumesaku.tech//host/x.png` という別物になる
  if (value.startsWith("/") && !value.startsWith("//")) {
    return `${ORIGIN}${value}`;
  }
  return null;
}

/** 生成に頼るのはサムネイルが無いコースだけ */
export function generatedLessonOgImageUrl(
  courseSlug: string,
  lessonSlug: string,
): string {
  return `${ORIGIN}/api/og/lesson/${courseSlug}/${lessonSlug}.png`;
}

export function lessonOgImageUrl(input: LessonOgImageInput): string {
  return (
    absoluteImageUrl(input.courseOgpImageUrl) ??
    absoluteImageUrl(input.courseThumbnailUrl) ??
    generatedLessonOgImageUrl(input.courseSlug, input.lessonSlug)
  );
}
